import { render, staticRenderFns } from "./hur-ofta.vue?vue&type=template&id=322ad290&scoped=true"
import script from "./hur-ofta.vue?vue&type=script&lang=js"
export * from "./hur-ofta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322ad290",
  null
  
)

export default component.exports